(function() {
  "use strict";

  angular
    .module("app")
    .controller("DomainIndicatorPickerController", [
      "$scope",
      "$location",
      "LegendService",
      DomainIndicatorPickerController
    ]);

  function DomainIndicatorPickerController($scope, $location, LegendService) {
    $scope.state.mapLegend = undefined;
    $scope.legend.colorByCommunity = {};

    $scope.state.refreshLegend = function() {
      LegendService.getLegend($scope.state.selectedIndicator.id).then(function(
        response
      ) {
        $scope.state.mapLegend = response;

        // When the indicator changes, the community data does too.
        // Re-style each community to display the proper ranking
        $scope.state.communityData.forEach(function(community, ind, arr) {
          var commIndValue =
            community.indicators[$scope.state.selectedIndicator.id];
          if (commIndValue && commIndValue.value) {
            $scope.state.mapLegend.forEach(function(legend, ind, arr) {
              if (
                commIndValue.value <= legend.highDataValue &&
                commIndValue.value >= legend.lowDataValue
              ) {
                community.indicatorGroup = ind;
                $scope.legend.colorByCommunity[community.id] =
                  $scope.legend.colors[ind];
              }
            });
          }

          $scope.rrMap.styleShape(community.fips);
        });
      });
    };

    $scope.$watch("state.selectedIndicator", function(oldVal, newVal) {
      if (oldVal === newVal) {
        return false;
      }

      $scope.state.indicatorPickerIsOpen = false;
      $scope.state.refreshLegend();
      $location.search("indicator", $scope.state.selectedIndicator.id);

      // Tracks when users select different Risk Ranking indicators from a drop down under a domain (e.g. health) on the "Asset Mapping" page
      dataLayer.push({
        event: "Risk Ranking Indicator Click on Asset Page",
        eventCategory: "Interactive Clicks",
        eventAction: "Domain Indicator |" + $scope.state.selectedIndicator.name,
        eventLabel: window.location.pathname
      });
    });

    if ($location.search().indicator) {
      $scope.state.selectedIndicator = $scope.state.selectedDomain.indicators.find(
        function(indicator) {
          if (indicator.id == $location.search().indicator) {
            return indicator;
          }
        }
      );
    }

    if (!$scope.state.selectedIndicator) {
      $scope.state.selectedIndicator = $scope.state.selectedDomain.indicators.find(
        function(indicator) {
          if (indicator.id == $scope.state.selectedDomain.id) {
            return indicator;
          }
        }
      );
    }

    if (!$scope.state.selectedIndicator) {
      $scope.state.selectedIndicator =
        $scope.state.selectedDomain.indicators[
          $scope.state.selectedDomain.indicators.length - 1
        ];
    }
  }
})();
